import React from "react";
import { connect } from "react-redux";
import { AppState } from "src/redux/store";
import Sidebar from "src/components/Sidebar";
import { StatusProject } from "src/redux/projects";
import { getProject, getPrestation } from "src/redux/projects/selectors";
interface Props {
  currentLocation: string;
  projectId: number | null;
  prestationId: number | null;
}
function mapStateToProps(state: AppState, props) {
  return {
    contact: state.user.contact,
    projects: state.projects.projects.filter(
      p => p.status === StatusProject.InProgress
    ),
    project: getProject(state.projects, props),
    prestation: getPrestation(state.projects, props)
  };
}

type PropsWithMapStateToProp = Props & ReturnType<typeof mapStateToProps>;

/**
 * Main container of our app, handle common logic:
 * showing available apps etc...
 */
class SidebarContainerToConnect extends React.Component<
  PropsWithMapStateToProp
> {
  render() {
    return (
      <Sidebar
        contact={this.props.contact}
        projects={this.props.projects}
        project={this.props.project}
        prestation={this.props.prestation}
        currentLocation={this.props.currentLocation}
      />
    );
  }
}

export const SidebarContainer = connect(mapStateToProps)(
  SidebarContainerToConnect
);



// WEBPACK FOOTER //
// ./src/containers/SidebarContainer.tsx